__turbopack_context__.v({
  "accordionSlideOverwrite": "drawer-module-scss-module__ps0FHG__accordionSlideOverwrite",
  "contentScrollContainer": "drawer-module-scss-module__ps0FHG__contentScrollContainer",
  "drawer": "drawer-module-scss-module__ps0FHG__drawer",
  "fadeIn": "drawer-module-scss-module__ps0FHG__fadeIn",
  "fadeOut": "drawer-module-scss-module__ps0FHG__fadeOut",
  "handle": "drawer-module-scss-module__ps0FHG__handle",
  "handleContainer": "drawer-module-scss-module__ps0FHG__handleContainer",
  "overlay": "drawer-module-scss-module__ps0FHG__overlay",
  "scaleIn": "drawer-module-scss-module__ps0FHG__scaleIn",
  "scaleOut": "drawer-module-scss-module__ps0FHG__scaleOut",
  "zoomIn": "drawer-module-scss-module__ps0FHG__zoomIn",
  "zoomOut": "drawer-module-scss-module__ps0FHG__zoomOut",
});
